import React from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import HelpCenterStaticPageComponent from "./HelpCenterStaticPageComponent";
import { privacyPolicyData } from "../../Api/help-center-json-data/privacy-policy";

const PrivacyPolicyTabComponent = () => {
  const styles = useStyles();

  return (
    <View
      style={{
        backgroundColor: AppColors.appBlueColor_3A5175,
        borderRadius: 10,
        padding: 20,
      }}
    >
      <View style={{ gap: 20 }}>
        <View style={styles.contentContainer}>
          <HelpCenterStaticPageComponent
            heading={privacyPolicyData.PrivacyPolicy.Heading}
            subHeading={privacyPolicyData.PrivacyPolicy.SubHeading}
            steps={privacyPolicyData.PrivacyPolicy.Steps}
          />
        </View>
      </View>
    </View>
  );
};

export default PrivacyPolicyTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    tabContainer: {
      flexDirection: "row",
      gap: 20,
    },
    tabButton: {
      alignItems: "center",
      paddingVertical: 8,
      flexDirection: "row",
      backgroundColor: AppColors.gray_6E90B4,
      justifyContent: "space-between",
      paddingHorizontal: 10,
      borderRadius: 10,
      width: 154,
      height: 45,
    },

    contentContainer: {
      marginTop: 10,
      paddingHorizontal: 10,
    },
    arrowIcon: {
      width: 10,
      height: 5,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: { tabButton: { height: 29, width: 140 } },
    [DEVICE_SIZES.XS]: { tabButton: { height: 29, width: 140 } },
  }
);
